import { render, staticRenderFns } from "./ServerList.vue?vue&type=template&id=88b84250&scoped=true"
import script from "./ServerList.vue?vue&type=script&lang=js"
export * from "./ServerList.vue?vue&type=script&lang=js"
import style0 from "./ServerList.vue?vue&type=style&index=0&id=88b84250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b84250",
  null
  
)

export default component.exports